export const rules = {
  name: [
    { required: true, message: 'Пожалуйста укажите наименование', trigger: 'blur' },
  ],
};